import { css } from '@emotion/react';
import { useTheme } from '@mui/material';

const useStyle = () => {
  const theme = useTheme();

  const { primary, error, background } = theme.palette;
  const { shadows } = theme;
  const { sm } = theme.breakpoints;

  const hidden = css`
    display: flex;
    visibility: hidden;
    height: 0;
    width: 0;
    opacity: 0;
    overflow: hidden;
  `;

  const showLabelStyles = css`
    position: absolute;
    top: 6px;
    left: 20px;
    font-size: 16px;
    line-height: 21px;
    font-weight: 100;
  `;

  const showLabelInputStyle = css`
    padding: 6px 20px;

    &:focus {
      padding: 12px 18px 3px 18px;
    }

    &:not(:placeholder-shown) {
      padding: 12px 18px 3px 18px;
    }
    &:focus:not(:placeholder-shown) {
      padding: 12px 18px 3px 17px;
    }
  `;

  const inputWrapper = css`
    margin: 0 0 15px;
    width: 100%;
    position: relative;

    & > * {
      transition: all 0.35s ease;
    }

    & > input:focus-visible {
      border: 2px solid ${primary.main};
      outline: none;
    }
  `;

  const input = css`
    width: 100%;
    height: 34px;
    padding: 6px 20px;
    font-size: 16px;
    line-height: 21px;
    font-weight: 400;
    margin: 0 auto;
    border: 1px solid ${primary.main};
    color: ${primary.main};

    &:focus + label {
      left: 20px;
      top: 4px;
      font-size: 8px;
      line-height: 8px;
      color: #515151;
    }

    &:not(:placeholder-shown) + label {
      left: 4px;
      top: 1px;
      color: #515151;
      left: 20px;
      top: 4px;
      font-size: 8px;
      line-height: 8px;
    }

    &:invalid + label {
      display: none;
      opacity: 0;
    }

    &:disabled {
      border: 1px solid ${background.gray};
      color: ${background.gray};
      background: inherit;
    }
  `;

  const errorInput = css`
    border: 2px solid ${error.light};
    color: ${error.light};

    &:focus-visible,
    &:active {
      border: 2px solid ${error.light};
    }
  `;

  const errorMessage = css`
    color: ${error.light};
    padding: 0px 20px;
  `;

  const inputEndActions = css`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
  `;

  const inputEndAction = css`
    position: relative;

    &:hover > div {
      display: block;
    }
  `;

  const questionToolTipStyle = css`
    position: absolute;
    right: 0;
    bottom: 55px;
    display: none;
    animation: fade-in 0.5s ease;
    background: ${background.gray3};
    border-radius: 15px;
    box-shadow: ${shadows[1]};
    padding: 35px 25px;
    width: 66vw;
    max-width: 436px;
    text-align: center;
    font-weight: 300;

    @media (max-width: ${`${sm}px`}) {
      width: calc(100vw - 100px);
      min-width: 100px;
    }

    @keyframes fade-in {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `;

  return {
    hidden,
    inputWrapper,
    input,
    errorInput,
    errorMessage,
    showLabelStyles,
    showLabelInputStyle,
    inputEndActions,
    inputEndAction,
    questionToolTipStyle,
  };
};

export default useStyle;
